import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course05 from "../../../course/course-05/course";
import lesson0517 from "../lesson-17/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "bd5588c8-d5b8-4f04-b4a2-c9aa6d5259d5",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0517),
    lesson: lesson0517,
  },
];

export default lessonLinks;
